import { useGetGroupByIdQuery } from '../features/graph/services/graphApi';
import type { RBACGroup } from '../types';

// Resolve the group selected via a URL id (/roles/:roleId, /acls/:aclId): prefer the
// already-loaded picker list, falling back to a direct by-id fetch so a group that
// isn't in the list yet still shows — e.g. a freshly-created one that Graph's
// eventually-consistent search hasn't indexed (getGroupById retries the
// read-your-write 404, ADR-0003).
//
// Uses RTK Query's `currentData`, NOT `data`, for the fallback: `data` retains the
// last fetched value after the query is skipped, which would keep the selection (and
// the page's detail header) populated after the search is cleared. `currentData`
// clears on skip, so dropping the id resolves to undefined and the details close —
// matching the Users page.
export function useSelectedGroup(
  id: string | undefined,
  list: RBACGroup[] | undefined
): RBACGroup | undefined {
  const { currentData } = useGetGroupByIdQuery(id ?? '', { skip: !id });
  return list?.find((group) => group.id === id) ?? currentData;
}
